import { SET_PENDINGTODOS } from "../actions/actionsTypes";

const initiState = {
  completedTodos: 0,
  totalTodos: 0,
  topTodos: [],
};

export const pendingTodosReducer = (state = initiState, action) => {
  if (action.type === SET_PENDINGTODOS) {
    const { completedTodos, topTodos, totalTodos } = action.payload;
    return { completedTodos, topTodos, totalTodos };
  }
  return state;
};
